module.exports = __webpack_public_path__ + "img/minetest.png";